import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';

import { Table } from './components/Table';

/**
 * RecommendationResponses
 *
 * Displays recommendations from Common Intake Platform (CIP)
 *
 * @param actionPath
 * @returns {Element}
 * @constructor
 */
export function RecommendationResponses({
  actionPath = {
    recordActions: [],
  },
}) {
  const [recommendationResponses, setRecommendationResponses] = useState([]);

  /**
   * Map api response to table data
   */
  useEffect(() => {
    const theRecommendations = [];

    if (!isEmpty(actionPath?.recordActions)) {
      actionPath?.recordActions.forEach((recordAction) => {
        if (!isEmpty(recordAction?.recordReferences)) {
          recordAction?.recordReferences.forEach((recordReference) => {
            theRecommendations.push({
              assignedCode: recordReference?.actionTaken,
              assignedDescription: recordReference?.actionTakenCodeDesc,
              statusCode: recordReference?.status,
              statusDate: recordReference?.lastModifiedDate,
            });
          });
        }
      });
    }

    if (!isEmpty(theRecommendations) && theRecommendations !== recommendationResponses) {
      setRecommendationResponses(theRecommendations);
    }
  }, [actionPath]);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/ActionPaths/components/RecommendationResponses/RecommendationResponses.jsx">
      <Grid>
        <Grid.Col span={{ xs: '100%' }}>
          <Table recommendationResponses={recommendationResponses || []} />
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
